// Public DaData token used by browser-side address and city suggestions.
export const DADATA_PUBLIC_TOKEN = 'e708eca2a8f173bab2e7b870ca8f4199a5988340';
